import React, { useContext, useRef } from 'react';
import DropdownMenu from './DropdownMenu.js';
import DropdownMenuItem from './DropdownMenuItem.js';
import { NavbarContext } from './NavbarContext.js';

const ApplicationSwitcherAppInstanceDropdown = ({ setPopperElement, isOpenInstance, styles, attributes, getMenuProps, setAppInstancesOpen, item, highlightedIndexMenu, menuRef, setHighlightedIndex, highlightedIndex, getItemPropsMenu }) => {
    const { appSwitcherLinkWrapper } = useContext(NavbarContext);
    const dropdownMenuRef = useRef();
    return (React.createElement(DropdownMenu, Object.assign({ inNavbar: true, maxWidth: '300px', ref: setPopperElement, isOpen: isOpenInstance, className: 'helix-unified-nav__overflow-dropdown-menu', style: Object.assign(Object.assign({}, styles.popper), { zIndex: 1052 }) }, attributes.popper),
        React.createElement("ul", Object.assign({}, getMenuProps({
            ref: dropdownMenuRef,
            onKeyDown: (e) => {
                switch (e.key) {
                    case 'Escape':
                        e.preventDefault();
                        setAppInstancesOpen([]);
                        break;
                    case 'ArrowDown':
                        e.preventDefault();
                        // if active item is last item in list
                        // close menu
                        if (item.appInstances && highlightedIndexMenu === item.appInstances.length - 1) {
                            if (menuRef) {
                                const menu = menuRef.childNodes[0];
                                if (menu) {
                                    setTimeout(() => {
                                        setAppInstancesOpen([]);
                                        menu.focus();
                                        setHighlightedIndex &&
                                            highlightedIndex &&
                                            setHighlightedIndex(highlightedIndex + 1);
                                    });
                                }
                            }
                        }
                        break;
                    case 'ArrowUp':
                        e.preventDefault();
                        // if active item is first item in list
                        // close menu
                        if (highlightedIndexMenu === 0) {
                            if (menuRef) {
                                const menu = menuRef.childNodes[0];
                                if (menu) {
                                    setTimeout(() => {
                                        setAppInstancesOpen([]);
                                        menu.focus();
                                        setHighlightedIndex &&
                                            highlightedIndex &&
                                            setHighlightedIndex(highlightedIndex);
                                    });
                                }
                            }
                        }
                        break;
                    case 'Enter':
                        e.preventDefault();
                        // stop event propagation
                        e.stopPropagation();
                        // if has url click the link
                        if (dropdownMenuRef &&
                            dropdownMenuRef.current &&
                            item.appInstances &&
                            item.appInstances[highlightedIndexMenu].url) {
                            // find the dom element and click it
                            const link = dropdownMenuRef.current.querySelectorAll('a')[highlightedIndexMenu];
                            if (link) {
                                link.click();
                            }
                        }
                        setTimeout(() => {
                            setAppInstancesOpen([]);
                            if (menuRef) {
                                const menu = menuRef.childNodes[0];
                                if (menu) {
                                    menu.focus();
                                }
                            }
                        });
                        break;
                    case 'Home':
                    case 'End':
                        e.stopPropagation();
                        e.preventDefault();
                        break;
                }
            }
        }, { suppressRefError: true })), item.appInstances &&
            item.appInstances.map((appInstance, index) => (React.createElement(DropdownMenuItem, { getItemProps: getItemPropsMenu, index: index, highlightedIndex: highlightedIndexMenu, key: appInstance.label, menuItem: appInstance, linkWrapper: appSwitcherLinkWrapper, useChildrenInProps: true, useCheckmarkActive: true, onClick: (e) => {
                    e.stopPropagation();
                    setAppInstancesOpen([]);
                } }))))));
};
ApplicationSwitcherAppInstanceDropdown.displayName = 'ApplicationSwitcherAppInstanceDropdown';

export { ApplicationSwitcherAppInstanceDropdown as default };
//# sourceMappingURL=ApplicationSwitcherAppInstanceDropdownMenu.js.map
